// no-dd-sa:javascript-code-style/parameter-name
import _ from 'lodash';
import moment from 'moment';

export const xpath = (obj, path) => {
  let xpath_ = (o, path_list) => {
    if (!path_list || path_list.length < 1) return o;
    return o && xpath_(o[path_list[0]], path_list.slice(1));
  };
  return xpath_(obj, path.split('.'));
};

export const isKeyMatched = (datum, key) => {
  const v = xpath(datum, key.key);
  return v === key.val;
};

export const isGroupKeyMatched = (datum, keys) => {
  return keys.every((key) => isKeyMatched(datum, key));
};

export const keyName = (meta, key) => (meta?.[key.val] ? meta[key.val].name || meta[key.val] : key.val);
export const keysName = (meta, keys) => keys.map((key) => keyName(meta, key)).join(' ');

export const groupKeys = (data, group_by) => {
  // no-dd-sa:javascript-code-style/assignment-name
  let group_by_keys = {};
  group_by.forEach((k) => {
    data.data.forEach((d) =>
      d.forEach((item) => {
        const v = xpath(item, k);
        if (v) {
          let kk = group_by_keys[k] || [];
          if (kk.indexOf(v) < 0) {
            kk.push(v);
            group_by_keys[k] = kk;
          }
        }
      }),
    );
  });
  let keys = [[]];
  group_by.forEach((g) => {
    const kk = group_by_keys[g];
    keys = _.flatMap(keys, (k) =>
      kk.map((i) => {
        // no-dd-sa:javascript-code-style/assignment-name
        let new_key = { ...k };
        new_key = k.concat([{ key: g, val: i }]);
        return new_key;
      }),
    );
  });
  return keys;
};

const idem = (x) => x;
export const getFormatter = (fmt) => {
  if (!fmt) return idem;
  if (fmt.startsWith('time:')) {
    let f = fmt.substring(5);
    return (s) => moment(s).format(f);
  }
  if (fmt.startsWith('ignore:')) {
    let comps = fmt.split(':');
    if (comps.length < 1 || comps[1].length < 1) {
      if (comps.length < 2 || comps[2]) {
        return idem;
      } else {
        const up = parseFloat(comps[2]);
        return (s) => (s > up ? '' : s);
      }
    } else {
      const down = parseFloat(comps[1]);
      // console.log(down);
      // no-dd-sa:javascript-code-style/no-lonely-if
      if (comps.length < 2 || comps[2]) {
        return (s) => (s < down ? '' : s);
      } else {
        const up = parseFloat(comps[2]);
        return (s) => (s > up || s < down ? '' : s);
      }
    }
  }
  return idem;
};
